import * as mobile from './util.mobile';
import request from './util.request';

// https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object["assign"] = function assign(target, varArgs) { // .length of function is 2
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  }
};

if (typeof Element !== 'undefined' && Element.prototype.getAttributeNames == undefined) {
  Element.prototype.getAttributeNames = function () {
    var attributes = this.attributes;
    var length = attributes.length;
    var result = new Array(length);
    for (var i = 0; i < length; i++) {
      result[i] = attributes[i].name;
    }
    return result;
  };
}

function isArray(o) {
  return Object.prototype.toString.call(o) === '[object Array]';
}
function isObject(obj) {
  return obj && obj.toString() === "[object Object]" || false;
}

function isFunction(obj) {
  return obj && typeof obj === 'function' || false;
}

function isPlainObject(obj) {
  //判断是否非window和DOM对象的对象，
  if (!isObject(obj) || obj.nodeType || obj.setInterval) {
    return false;
  }

  //constructor是对创建对象的函数的引用（指针）。对于 Object 对象，该指针指向原始的 Object() 函数
  //判断obj是否具有isPrototypeOf属性，isPrototypeOf是挂在Object.prototype上的。通过字面量或自定义类（构造器）创建的对象都会继承该属性方法
  if (obj.constructor && !obj.hasOwnProperty("constructor") && !obj.constructor.prototype.hasOwnProperty("isPrototypeOf")) {
    return false;
  }

  var key;
  for (key in obj) { }

  return key === undefined || obj.hasOwnProperty(key);
}

function each(obj, cb) {
  if (!isFunction(cb)) {
    return;
  }

  if (isObject(obj)) {
    for (var k in obj) {
      cb(k, obj[k], obj);
    }
  } else if (Array.isArray(obj)) {
    for (var i = 0, len = obj.length; i < len; i++) {
      cb(i, obj[i], obj);
    }
  }
}
function parseHref(url) {
  var adom = document.createElement('a');
  adom.href = url;
  return {
    domain: adom.hostname,
    pathname: adom.pathname,
    search: adom.search,
    hash: adom.hash
  };
}
function delParam(url, name) {
  var reg = new RegExp('(\\?|#|&)' + name + '=([^&]*)(&|$)', 'g');
  return url.replace(reg, '$1$3').replace(/(\?|#|&)$/, '').replace(/(#|\?)&/g, '$1');
}

function matches(el, selector) {
  var _matches = el.matches ||
    el.matchesSelector ||
    el.msMatchesSelector ||
    el.mozMatchesSelector ||
    el.webkitMatchesSelector ||
    el.oMatchesSelector

  if (_matches) {
    return _matches.call(el, selector)
  } else if (el.parentNode) {
    // IE8 and below
    var nodes = el.parentNode.querySelectorAll(selector)
    for (var i = nodes.length; i--; 0) {
      if (nodes[i] === el) return true
    }
    return false
  }
}
function closest(el, sel) {
  if (!el) return
  if (matches(el, sel)) {
    return el
  } else {
    return closest(el.parentNode, sel)
  }
}
/**
 * 1PC 2H5 3native andriod 4native ios 5PC客户端  7小程序
 */
function getPlatform() {
  const isMobile = mobile.isMobile();
  const isApp = mobile.isApp();
  const isMini = mobile.isMiniProgram();
  const isPCClient = mobile.isPCClient();
  const isWinClient = mobile.isWinClient();
  const isMacClient = mobile.isMacClient();
  const isWinClientLite = mobile.isWinClientLite();
  const isMacClientLite = mobile.isMacClientLite();
  const isAndroid = mobile.isAndroid();
  const isIOS = mobile.isIOS();

  const map = {
    1: !isMobile && !isPCClient,
    2: isMobile && !isApp && !isMini,
    3: isMobile && isApp && isAndroid,
    4: isMobile && isApp && isIOS,
    5: !isMobile && isWinClient,
    6: !isMobile && isMacClient,
    7: isMobile && isMini,
    9: !isMobile && isWinClientLite,
    10: !isMobile && isMacClientLite
  };

  return parseInt(Object.keys(map).filter(k => map[k])[0], 10) || 1;
}

function getEnvironment() {
  if (mobile.qqVersion()) {
    return 'QQ';
  }

  if (mobile.isWeixin()) {
    return 'WX';
  }

  if (mobile.isBaiduApp()) {
    return 'Baidu';
  }

  if (mobile.isWeiboApp()) {
    return 'Sina';
  }

  if (mobile.isApp()) {
    return 'edu_APP';
  }

  return 'other';
}

function isInIframe() {
  return window.top && window.top.window !== window;
}

export default Object.assign({
  isPlainObject,
  isFunction,
  isObject,
  isArray,
  loadJSONP: request.loadJSONP,
  closest,
  each,
  delParam,
  getPlatform,
  parseHref,
  getEnvironment,
  isInIframe
}, mobile);
